// extracted by mini-css-extract-plugin
export default {"formButtons":"FormButtons_formButtons__p8QT1"};